// extracted by css-extract-rspack-plugin
export default {"root":"HP_AAFe5ok4oICb1"};